<div class="container-fluid">
    <div class="row">
        <div class="page-title">
            <h3>{{ 'orders_list.admin_title' | translate }}</h3>
        </div>
    </div>
    <div class="row">
        <div class="col-12">

            <div *ngIf="loading" class="text-center py-5">
                <div class="spinner-border text-success" role="status">
                    <span class="visually-hidden">{{ 'common.loading' | translate }}...</span>
                </div>
            </div>

            <div *ngIf="!loading && orders?.length === 0" class="text-center py-5">
                <i class="fa fa-box-open fa-3x text-muted mb-3"></i>
                <p class="text-muted">{{ 'orders.no_orders' | translate }}</p>
            </div>

            <div *ngIf="!loading && orders?.length > 0">
                <div class="order-row" *ngFor="let order of orders | paginate: config; let i = index;">
                    <div class="order-card">
                        <div class="order-card-top">
                            <div class="order-card-date">
                                <span class="order-card-label">{{ 'orders_list.ordered_at' | translate }}</span>
                                <span class="order-card-value">{{ formatDate(order.createdAt) }}</span>
                            </div>
                            <div class="order-card-ref">
                                <span class="order-card-label">{{ 'orders_list.ref' | translate }}</span>
                                <span class="order-card-value">#{{ order.orderNumber }}</span>
                            </div>
                        </div>
                        <div class="order-card-bottom">
                            <div class="order-card-meta">
                                <span [class]="getStatusClass(order.status)">{{ order.status }}</span>
                                <span class="order-card-payment-method" *ngIf="order.payment?.paymentMethod">
                                    <i class="fa fa-credit-card me-1"></i>
                                    {{ getPaymentMethodLabel(order.payment.paymentMethod) }}
                                </span>
                                <span class="order-card-payment-method" *ngIf="order.orderBy">
                                    <i class="fa fa-user me-1"></i>
                                    {{ order.orderBy }}
                                </span>
                            </div>
                            <div class="order-card-actions">
                                <a [routerLink]="['/admin', 'orders', order.orderNumber]"
                                   class="btn btn-success order-view-btn">
                                    {{ 'orders.view_details' | translate }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row" *ngIf="!loading && config && config.totalOfPage > 1">
                <div class="col-12">
                    <div class="pager">
                        <pagination-controls class="pages"
                                             maxSize="5"
                                             [previousLabel]="'common.previous' | translate"
                                             [nextLabel]="'common.next' | translate"
                                             autoHide="true"
                                             id="adminOrders"
                                             (pageChange)="pageChange($event)">
                        </pagination-controls>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
